import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="kupidon-shell flex flex-col items-center justify-center p-8" style={{ minHeight: "100vh", background: "#FFF5F0" }}>
          <div style={{ fontFamily: "Onest, sans-serif", textAlign: "center", maxWidth: 400 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8, color: "#3D2C20" }}>
              Что-то пошло не так
            </h1>
            <pre style={{ fontSize: 12, color: "#E76F51", background: "#FFE0CC", padding: 12, borderRadius: 12, textAlign: "left", overflow: "auto", maxHeight: 200, marginTop: 12 }}>
              {this.state.error?.message || "Unknown error"}
            </pre>
            <button
              onClick={() => { this.setState({ error: null, info: null }); window.location.href = "/"; }}
              style={{
                marginTop: 16,
                padding: "12px 32px",
                borderRadius: 100,
                border: "none",
                background: "#3D2C20",
                color: "white",
                fontSize: 16,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              На главную
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}